// This component is now just a trigger dispatcher.

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { modalDatumView, modalItemView } from '../../actions/ModalAction';

export default ({ open, setOpen }) => {
  const { modalData } = useSelector((state) => state.modalReducer);
  const { user } = useSelector((state) => state.authReducer.authData);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!open || !modalData) return;

    if (modalData.modalType === "referenceDatum") {
      dispatch(modalDatumView(modalData._id));
    } else if (modalData.modalType === "referenceItem") {
      dispatch(modalItemView(modalData._id, user._id, {}));
    }
  }, [open, modalData?._id]);

  return null; // GeneralModal handles rendering
};